<template>
    <div>
        <Cover v-if="!isDesktop && !$store.getters.coverHidden"/>
        <template v-else>
            <Menu/>
            <transition name="page" mode="out-in">
                <router-view class="view"/>
            </transition>
            <FooterFixed class="footer"/>
        </template>
    </div>
</template>

<script>
import {Vue, Component} from 'vue-property-decorator'
import Menu from "@/views/client/Menu";
import Cover from "@/views/Cover";
import Footer from "@/views/client/Footer";
import FooterFixed from "@/views/client/FooterFixed";
@Component({
    components: {FooterFixed, Menu, Cover, Footer}
})
export default class Wrapper extends Vue {
    get products() {
        return this.$store.getters.products
    }

    get isDesktop () {
        return window.innerWidth > 460
    }
}
</script>
<style lang="scss">
@import "src/assets/style/hamburgers.scss";

/* Page (route) transition — opacity only, so it never becomes a containing
   block for fixed children (e.g. Home's scroll dots). ease-out feels smoother. */
.page-enter-active {
    transition: opacity 0.32s ease-out;
}
.page-leave-active {
    transition: opacity 0.22s ease-in;
}
.page-enter,
.page-leave-to {
    opacity: 0;
}

/* Home image reveal (<transition-group name="fade">) — gentle fade + rise. */
.fade-enter-active {
    transition: opacity 0.45s ease-out, transform 0.45s ease-out;
}
.fade-enter {
    opacity: 0;
    transform: translateY(10px);
}
.fade-leave-active {
    transition: opacity 0.3s ease;
}
.fade-leave-to {
    opacity: 0;
}
</style>
<style scoped lang="scss">
@import 'src/assets/style/media-query';
@import 'src/assets/style/common';

.view {
    max-width: $view-max-width;
    margin: auto;
    position: relative;
    @include desktop {
        min-height: calc(100vh - #{$nav-height-desktop + 139});
        width: 80%;
        padding-top: $nav-height-desktop;
    }
    @include mobile {
        min-height: calc(100vh - #{$nav-height-mobile + 130});
        width: 100%;
        padding-top: $nav-height-mobile;
    }
}
</style>
